module.exports = __webpack_public_path__ + "static/media/Sea Rescuer.f7f9e4c9.jpg";